import { ICustomerData } from "shared/components/AuthModal/types";

export enum SIGNUP_ERROR_CODE {
    ERROR = 1,
    SUCCESS = 0,
}

interface ISingupError {
    error: SIGNUP_ERROR_CODE.ERROR;
    message: string;
    customer_id: null;
}

interface ISignupSuccess {
    error: SIGNUP_ERROR_CODE.SUCCESS;
    customer_id: string;
    message: string;
    response: {
        form_key: string;
        cartCount: number;
        customerData: ICustomerData;
    };
}

export type ISignupResponse = ISingupError | ISignupSuccess;
